import styled from 'styled-components';
import React, { useState } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { X, VideoBackGround, Rectangle13, Rectangleandgreychek } from '../../Constants/assets';
// Stylings

const OuterContainer = styled.div`
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    z-index: 28;
    pointer-events: all;
`;
const InnerContainer = styled.div`
    width: 500px;
    height: 338px;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
    position: absolute;
    font-family: 'Roboto', sans-serif;
    z-index: 27;
    animation: zoomIn 0.2s ease-in-out;
    top: 50%;
    left: calc(50% - 169px);
    transform: translate(-50%, -50%);
`;
const TextContainer = styled.div`
    height: 65%;
    margin-top: -20px;
`;
const Br = styled.div`
    height: 15%;
`;
const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 95%;
    height: 22%;
`;
const HeaderText = styled.div`
    font-weight: bold;
    font-size: 24px;
    line-height: 100%;
    color: ${props => props.theme.colors.black};
    height: 95%;
    width: 70%;
`;
const ParagraphText = styled.div`
    font-size: 16px;
    line-height: 135%;
    color: ${props => props.theme.colors.black};
    width: 80%;
    display: inline-table;
`;
// export const checkedbegin = beginCheckboxChecked;
// TODO: Fix this, this is temporary fix
export default function NetworkErrorPopUp({ show }) {
    if (show) {
        return (
            <OuterContainer>
                <InnerContainer>
                    <Br />
                    <TextContainer>
                        <HeaderContainer>
                            <HeaderText>Unable to connect</HeaderText>
                        </HeaderContainer>
                        <ParagraphText style={{ textAlign: 'left' }}>
                            {' '}
                            You don't seem to have an active internet connection.
                            <br />
                            Please check your connection and try again.
                            <br /> <br />
                        </ParagraphText>
                    </TextContainer>
                </InnerContainer>
            </OuterContainer>
        );
    }
    return null;
}
